import { useState } from 'react'
import {
  Button,
  Divider,
  Flex,
  Form,
  Image,
  Input,
  Modal,
  Typography,
} from 'antd'
import { Task } from 'src/pages/worldCup2026/tasks/types'
import { submitModerationTask } from 'src/pages/worldCup2026/tasks/model'

type Props = {
  isVisible: boolean
  onClose: () => void
  data: Task
}

export const ClientTaskModal = ({ isVisible, onClose, data }: Props) => {
  const [isDecline, setIsDecline] = useState(false)

  const [form] = Form.useForm()
  const { Item } = Form
  const { Text } = Typography
  const { TextArea } = Input

  const handleApprove = () => {
    submitModerationTask({
      id: String(data.id),
      status: 'accepted',
      declineReason: '',
    })
    onClose()
  }

  const handleReject = async () => {
    if (!isDecline) {
      setIsDecline(true)
      return
    }
    try {
      const value = await form.validateFields()
      submitModerationTask({
        id: String(data.id),
        status: 'declined',
        declineReason: value.declineReason,
      })
      form.resetFields()
      onClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Task</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      onCancel={onClose}
      footer={
        <Flex gap={8} justify="flex-end">
          <Button color="green" variant="solid" onClick={handleApprove}>
            Approve
          </Button>
          <Button color="volcano" variant="solid" onClick={handleReject}>
            Reject
          </Button>
        </Flex>
      }
    >
      <Divider />

      <Flex vertical>
        {data.checkType === 'image' ? (
          <Image
            className="mb-3"
            width={250}
            src={data.imgUrl}
            preview={false}
          />
        ) : (
          <a className="mb-3" href={data.checkValue} target="_blank">
            {data.checkValue}
          </a>
        )}
        {isDecline && (
          <Form layout="vertical" form={form}>
            <Item
              required={false}
              name="declineReason"
              label={
                <Text style={{ fontSize: 16 }} strong>
                  Decline reason
                </Text>
              }
              rules={[
                {
                  required: true,
                  message: 'Required field',
                },
              ]}
            >
              <TextArea rows={6} autoFocus placeholder="Reason" />
            </Item>
          </Form>
        )}
      </Flex>
      <Divider />
    </Modal>
  )
}
